import {
  httpClient,
  fetchClientToken,
  fetchLoyaltyToken,
  resetToken,
} from "@koala/sdk/v4";
import {
  BUILD_VERSION,
  ENV,
  clientId,
  clientSecret,
} from "@/constants/envConfig";
import {
  getAndroidShellDeviceId,
  getAndroidShellVersion,
} from "@/utils/android";

interface ClientOrigin {
  origin: string;
}

export function createHttpClient({ origin }: ClientOrigin) {
  const androidDeviceId = getAndroidShellDeviceId();
  const androidVersion = getAndroidShellVersion();
  return httpClient({
    credentials: { clientId, clientSecret },
    env: ENV,
    headers: {
      ...(androidDeviceId && { androidDeviceId }),
      ...(androidVersion && { androidVersion }),
      serviceLabel: `Koala Web Ordering / ${BUILD_VERSION}`,
    },
    origin,
  });
}

export async function getClientToken({ origin }: ClientOrigin) {
  const androidDeviceId = getAndroidShellDeviceId();
  const androidVersion = getAndroidShellVersion();
  return fetchClientToken({
    credentials: { clientId, clientSecret },
    env: ENV,
    headers: {
      ...(androidDeviceId && { androidDeviceId }),
      ...(androidVersion && { androidVersion }),
      serviceLabel: `Koala Web Ordering / ${BUILD_VERSION}`,
    },
    origin,
  });
}

export async function getLoyaltyToken(
  payload: Record<string, any>,
  { origin }: ClientOrigin
) {
  const androidDeviceId = getAndroidShellDeviceId();
  const androidVersion = getAndroidShellVersion();
  return fetchLoyaltyToken({
    credentials: { clientId, clientSecret },
    env: ENV,
    headers: {
      ...(androidDeviceId && { androidDeviceId }),
      ...(androidVersion && { androidVersion }),
      serviceLabel: `Koala Web Ordering / ${BUILD_VERSION}`,
    },
    origin,
    payload,
  });
}

export function resetLoyaltyToken({ origin }: ClientOrigin) {
  const androidDeviceId = getAndroidShellDeviceId();
  const androidVersion = getAndroidShellVersion();

  return resetToken({
    credentials: { clientId, clientSecret },
    env: ENV,
    headers: {
      ...(androidDeviceId && { androidDeviceId }),
      ...(androidVersion && { androidVersion }),
      serviceLabel: `Koala Web Ordering / ${BUILD_VERSION}`,
    },
    origin,
  });
}
